import React, { useContext, useEffect, useState } from "react";
import classes from "./auctions.module.css";
import Transporter from "./Transporter/Transporter";
import AuctionDetails from "./AuctionDetails/AuctionDetails";
import Axios from "../../../Axios";
import { Urls } from "../../../Urls";
import { toast } from "react-toastify";
import {
  Activity,
  currentRequestTimeStamp,
  isMobile,
} from "../../../Constants";
import { PROCURE_URLS } from '../../../Urls';
import { redirectToProcure } from '../../firebase/firebase';
import Stepper from "react-stepper-horizontal";
import "react-widgets/dist/css/react-widgets.css";
import { DateTimePicker } from "react-widgets";
import Moment from "moment";
import momentLocalizer from "react-widgets-moment";
import mixpanel from "mixpanel-browser";
import axios from "../../../Axios/Axios";
import Loader from "../../Loader";
import { decryptResponse } from "../../../Utility";
import { useMixPanelForTracking } from "../../../utils/TrackMixPanel";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../MyCompanyProfileContext";

Moment.locale("en");
momentLocalizer();

const Auctions = ({ auctionlist = [], company_name = "" }) => {
  const [procurementName, setProcurementName] = useState();
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [extendsby, setExtendsby] = useState(3);
  const [capLimit, setCapLimit] = useState(0);
  const [extendswhen, setExtendswhen] = useState(5);
  const [step, setStep] = useState(0);
  const [auction_details, setAuction_details] = useState([]);
  const [duration, setDuration] = useState(30);
  const [startdate, setStartdate] = useState();
  const [newStartdate1, setnewStartdate1] = useState();
  const [auction_transporter_list, setAuction_transporter_list] = useState([]);
  const [show, setshow] = useState(false);
  const [zone, setzone] = useState("PAN India");
  const [displayTransporter, setdisplayTransporter] = useState(false);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);

  /**
   * Formats a date to a "day/month/year" string.
   *
   * @param {Date} date - The date to be formatted.
   * @returns {string} The formatted date as "day/month/year".
   */
  const formatDate = (date) => {
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are zero-indexed.
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  /**
   * Handles the side effects for setting up procurement details and auction list.
   *
   * @hook
   * @returns {void}
   */
  //   useEffect(() => {
  //     setProcurementName(`LoRRI Spot Auction: ${formatDate(new Date())}`);
  //     // setStartdate(new Date())
  //     var temp_date = new Date();
  //     temp_date.setDate(temp_date.getDate() + 1);
  //     temp_date.setHours(11);
  //     temp_date.setMinutes(0);
  //     temp_date.setSeconds(0);
  //     setnewStartdate1(new Date());
  //     setStartdate(new Date(temp_date));

  //     var temp_list = [];
  //     var temp_id_list = [];
  //     var temp_transporter_list = [];

  //     if (auctionlist && auctionlist.length > 0) {
  //       setshow(true);
  //       auctionlist.map((enquiry) => {
  //         axios
  //           .get(`${Urls.spot}?truck_enquiry_id=${enquiry.truck_enquiry_id}`)
  //           .then((res) => {
  //             setshow(false);
  //             if (
  //               res.data &&
  //               res.data.enquiry_lane_details[0] &&
  //               res.data.enquiry_lane_details[0].benchmark_transporter_list &&
  //               res.data.enquiry_lane_details[0].benchmark_transporter_list
  //                 .length > 0
  //             ) {
  //               if (!enquiry.auction_created) {
  //                 var temp_enquiry_transporter_list =
  //                   res.data.enquiry_lane_details[0].benchmark_transporter_list.filter(
  //                     (transporter) => {
  //                       if (transporter.ischecked) {
  //                         if (
  //                           !temp_id_list.includes(transporter.transporter_id)
  //                         ) {
  //                           transporter.isProcurementLevel = true;
  //                           temp_id_list.push(transporter.transporter_id);
  //                           temp_transporter_list.push(transporter);
  //                         }
  //                         return transporter;
  //                       }
  //                     }
  //                   );

  //                 var temp = {
  //                   auction_id: enquiry.truck_enquiry_id,
  //                   auction_description: `${
  //                     enquiry.origin && enquiry.origin.location
  //                       ? enquiry.origin.location.location
  //                       : null
  //                   } - ${
  //                     enquiry.destination && enquiry.destination.location
  //                       ? enquiry.destination.location.location
  //                       : null
  //                   }, ${
  //                     Array.isArray(enquiry.truck_types)
  //                       ? enquiry.truck_types.map((ttt) => {
  //                           return ttt.value;
  //                         })
  //                       : enquiry.truck_types.label
  //                   }`,
  //                   bid_decrement_amount:
  //                     enquiry.transporter_list &&
  //                     enquiry.transporter_list.length > 0
  //                       ? parseInt(enquiry.transporter_list[0].rate * 0.01)
  //                       : 0,
  //                   auction_duration: duration,
  //                   start_timestamp: new Date(temp_date),
  //                   starting_amount:
  //                     enquiry.transporter_list &&
  //                     enquiry.transporter_list.length > 0
  //                       ? parseInt(enquiry.transporter_list[0].rate)
  //                       : 0,
  //                   auto_extend_by: extendsby,
  //                   auto_extend_when: extendswhen,
  //                   display_transporter_name: displayTransporter,
  //                   zone: zone,
  //                   unit_metric: enquiry?.unit_metric,
  //                   baseline_rate: enquiry.baseline_rate,
  //                   auction_status: "inactive",
  //                   transporter_list: temp_enquiry_transporter_list,
  //                 };
  //                 temp_list.push(temp);
  //               }
  //             }
  //           })
  //           .catch((err) => {
  //             setshow(false);
  //             console.log(err, "54");
  //           });
  //       });
  //       setAuction_transporter_list(temp_transporter_list);
  //       setAuction_details(temp_list);
  //     }
  //   }, [auctionlist]);

  useEffect(() => {
    if (!auctionlist || auctionlist.length === 0) return;

    const tempDate = new Date();
    tempDate.setDate(tempDate.getDate() + 1);
    tempDate.setHours(11, 0, 0, 0);

    setProcurementName(`LoRRI Spot Auction: ${formatDate(new Date())}`);
    setnewStartdate1(new Date());
    setStartdate(new Date(tempDate));
    let isCancelled = false;
    (async () => {
      try {
        setshow(true);

        const responses = await Promise.all(
          auctionlist.map((enquiry) =>
            axios
              .get(`${Urls.spot}?field=get_enquiry&truck_enquiry_id=${enquiry.truck_enquiry_id}`)
              .then((res) => ({ enquiry, res }))
              .catch((error) => ({ enquiry, error }))
          )
        );

        const tempList = [];
        const tempIdSet = new Set();
        const tempTransporterList = [];

        for (const item of responses) {
          const { enquiry, res, error } = item;
          if (error) {
            console.log(error, "54");
            continue;
          }

          const lane = res.data.enquiry_lane_details ? res.data.enquiry_lane_details[0] : res.data;
          const bench = lane?.benchmark_transporter_list;
          if (!bench || bench.length === 0) continue;
          if (enquiry.auction_created) continue;

          const selectedTransporters = bench
            .filter((transporter) => {
              const checked = transporter?.ischecked || transporter?.isChecked;
              return checked;
            })
            .map((t) => ({ ...t, ischecked: true }));

          selectedTransporters.forEach((transporter) => {
            if (!tempIdSet.has(transporter.transporter_id)) {
              tempIdSet.add(transporter.transporter_id);
              tempTransporterList.push({
                ...transporter,
                isProcurementLevel: true,
              });
            }
          });

          const auctionDescription = `${enquiry.lane_details?.origin?.location?.location ?? null
            } - ${enquiry.lane_details?.destination?.location?.location ?? null}, ${Array.isArray(enquiry.lane_details?.truck_types)
              ? enquiry.lane_details?.truck_types.map((ttt) => ttt.value).join(", ")
              : enquiry.lane_details?.truck_types?.label
            }`;

          tempList.push({
            auction_id: enquiry.truck_enquiry_id,
            auction_description: auctionDescription,
            bid_decrement_amount: enquiry.transporter_list?.length
              ? parseInt(enquiry.transporter_list[0].rate * 0.01, 10)
              : 0,
            auction_duration: duration,
            start_timestamp: new Date(tempDate),
            starting_amount: enquiry.transporter_list?.length
              ? parseInt(enquiry.transporter_list[0].rate, 10)
              : 0,
            auto_extend_by: extendsby,
            auto_extend_when: extendswhen,
            display_transporter_name: displayTransporter,
            zone,
            unit_metric: enquiry?.unit_metric,
            baseline_rate: enquiry.baseline_rate,
            auction_status: "inactive",
            transporter_list: selectedTransporters,
          });
        }

        if (!isCancelled) {
          setAuction_transporter_list(tempTransporterList);
          setAuction_details(tempList);
        }
      } finally {
        if (!isCancelled) setshow(false);
      }
    })();

    return () => {
      isCancelled = true;
    };
  }, [auctionlist]);

  /**
   * Handles changes in auction settings.
   *
   * @param {string} key - The setting to be updated.
   * @param {number} value - The new value for the setting.
   * @returns {void}
   */
  const changeHandler = (key, value) => {
    if (key === "auction_duration") {
      setDuration(value);
    }
    if (key === "auto_extend_by") {
      setExtendsby(value);
    }
    if (key === "number_of_extension") {
      setCapLimit(value);
    }
    if (key === "auto_extend_when") {
      setExtendswhen(value);
    }
    var temp_list = auction_details.slice();
    var temp_list = temp_list.map((enquiry) => {
      enquiry[key] = value;
      return enquiry;
    });
    setAuction_details(temp_list);
  };

  /**
   * Updates the display of transporters based on user selection.
   *
   * @param {Event} e - The event triggered by user interaction.
   * @returns {void}
   */
  const transporterDisplaySelection = (e) => {
    if (e.target.id === "transporter_name") {
      setdisplayTransporter(true);
    } else {
      setdisplayTransporter(false);
    }
  };

  /**
   * Validates auction details before proceeding.
   *
   * @returns {boolean} True if details are valid, otherwise false.
   */
  const validatedetails = () => {
    Activity([
      {
        screen: "Truck Available",
        module: "Create Auction",
        user_activity: "Next Button Clicked",
        timestamp: currentRequestTimeStamp(),
        "userEmail": userDetails?.email, "userName": userDetails?.user_name, "companyname": userDetails.company_name
          ? userDetails.company_name
          : userDetails.email
            ? userDetails.email.split("@")[1].split(".")[0]
            : ""
      },
    ]);
    mixpanel.track(`User has clicked on Next button`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Trucksavailable",
      ModuleName: "my_enquiries",
      ActivityLog: "userClickedNextButton",
      Data: "User clicked on Next Button",
      Definition: `User has clicked on Next button`,
      ActivityType: "event_view",
      UserName: userDetails.user_name,
      UserEmail: userDetails.email,
      CompanyName: userDetails.company_name
        ? userDetails.company_name
        : userDetails.email
          ? userDetails.email.split("@")[1].split(".")[0]
          : "",
    });
    if (
      extendsby === 0 ||
      extendsby === null ||
      extendsby === undefined ||
      extendsby === ""
    ) {
      toast.info("Extends by cannot be zero");
      return false;
    } else if (
      extendswhen === 0 ||
      extendswhen === null ||
      extendswhen === undefined ||
      extendswhen === ""
    ) {
      toast.info("Extends when cannot be zero");
      return false;
    } else if (
      duration === 0 ||
      duration === null ||
      duration === undefined ||
      duration === ""
    ) {
      toast.info("Duration cannot be zero");
      return false;
    } else if (!startdate) {
      toast.info("Please Add valid Date");
      return false;
    } else {
      for (var i = 0; i < auction_details.length; i++) {
        var startingAmount = parseInt(auction_details[i].starting_amount);
        var bidDecrementAmount = parseInt(
          auction_details[i].bid_decrement_amount
        );
        if (!startingAmount || startingAmount === null || startingAmount <= 0) {
          toast.info("Opening Bid cannot be zero");
          return false;
        }
        if (startingAmount < bidDecrementAmount) {
          toast.info("Bid decrement cannot be greater than starting bid");
          return false;
        }
        if (startingAmount === bidDecrementAmount) {
          toast.info("Bid decrement cannot be equal to starting bid");
          return false;
        }
        if (
          !bidDecrementAmount ||
          bidDecrementAmount === null ||
          bidDecrementAmount <= 0
        ) {
          toast.info("Bid decrement cannot be zero");
          return false;
        }
        if (
          !auction_details[i].unit_metric ||
          auction_details[i].unit_metric <= 0
        ) {
          toast.info("Please Provide Valid Volume/Quantity");
          return false;
        }
        if (
          !auction_details[i].baseline_rate ||
          auction_details[i].baseline_rate <= 0
        ) {
          toast.info("Please Provide Valid Baseline Rate");
          return false;
        }
      }
      return true;
    }
  };

  /**
   * Creates a new auction and updates relevant details.
   *
   * @param {Event} e - The event triggered by user action.
   * @returns {void}
   */
  const createAuction = async (e) => {
    const sqlPattern =
      /\b(SELECT\s+\*|INSERT\s+INTO|DELETE\s+FROM|UPDATE\s+\w+|DROP\s+TABLE|ALTER\s+TABLE|TRUNCATE\s+TABLE|EXEC\s+\w+|UNION\s+SELECT)\b|(--|;|'|"|\/\*|\*\/)/gi;

    Activity([
      {
        screen: "Truck Available",
        module: "Create AUction",
        user_activity: "Create Auction button Clicked",
        timestamp: currentRequestTimeStamp(),
        "userEmail": userDetails?.email, "userName": userDetails?.user_name, "companyname": userDetails.company_name
          ? userDetails.company_name
          : userDetails.email
            ? userDetails.email.split("@")[1].split(".")[0]
            : ""
      },
    ]);
    if (sqlPattern.test(procurementName)) {
      alert("Please enter valid Procurement Name");
    } else if (
      extendsby === 0 ||
      extendsby === null ||
      extendsby === undefined
    ) {
      toast.info("Extends by cannot be zero");
    } else if (
      extendswhen === 0 ||
      extendswhen === null ||
      extendswhen === undefined
    ) {
      toast.info("Extends when cannot be zero");
    } else if (duration === 0 || duration === null || duration === undefined) {
      toast.info("Duration cannot be zero");
    } else if (!startdate) {
      toast.info("Please Add valid Date");
    } else {
      var auctions = auction_details.map((auction) => {
        auction.transporter_list = auction.transporter_list.filter(
          (transporter) => {
            if (transporter.ischecked || transporter.isChecked) {
              return transporter;
            }
          }
        );
        return auction;
      });

      var procurement_payload = {
        company: company_name,
        procurement_name: procurementName,
        transporter_list: [],
        auction_transporter_list: auction_transporter_list.map(
          (procurement_transporter) => {
            return procurement_transporter;
          }
        ),
      };

      Axios.post(
        `${Urls.auctionlorri}?create_procurement_id=true`,
        procurement_payload
      )
        .then((response) => {
          const res = { data: decryptResponse(response.data) };
          toast.success("Procurement created successfully");
          auctions.map((auction, index) => {
            TrackMixPanel({
              ModuleName: "lorri spot",
              ScreenName: "my enquiries - create auctions",
              Data: `no of ext: ${auction.number_of_extension}, auc desc: ${auction.auction_description}, bid dec: ${auction.bid_decrement_amount}, auc duration: ${auction.auction_duration}, start at: ${auction.start_timestamp}, starting amt: ${auction.starting_amount}, extend by: ${auction.auto_extend_by}, extend when: ${auction.auto_extend_when}, baseline: ${auction.baseline_rate}`,
              Definition: "user created auctions from enquiries",
            });


            var auction_payload = {
              allowed_deviation: 0,
              configure_freight_breakup_type: "",
              final_offer: false,
              freight_breakup_submission_duration: 0,
              freight_breakup_submission_timestamp: "",
              high_quote_percentage: 0,
              lot_no: "",
              low_quote_percentage: 0,
              number_of_extension: auction.number_of_extension ?? 0,
              auction_description: auction.auction_description,
              bid_decrement_amount: parseInt(auction.bid_decrement_amount),
              auction_duration: parseInt(auction.auction_duration),
              start_timestamp: auction.start_timestamp,
              starting_amount: parseInt(auction.starting_amount),
              auto_extend_by: parseInt(auction.auto_extend_by),
              auto_extend_when: parseInt(auction.auto_extend_when),
              display_transporter_name: displayTransporter,
              zone: zone,
              unit_metric: auction.unit_metric,
              baseline_rate: auction.baseline_rate,
              auction_status: "inactive",
              transporter_list: auction.transporter_list,
            };
            Axios.post(
              `${Urls.auctionlorri}?procurement_id=${res.data.data.procurement_id}`,
              auction_payload
            )
              .then((res) => {
                var enuqiry_to_auction_payload = {
                  truck_enquiry_id: auction.auction_id,
                  auction_created: true,
                };
                Axios.post(
                  `${Urls.spot}?field=edit_enquiry_v2`,
                  enuqiry_to_auction_payload
                )
                  .then((res) => {
                    if (index === auctions.length - 1) {
                      toast.success("Auctions Created");
                      setStep(2);
                    }
                  })
                  .catch((e) => console.log(e));
              })
              .catch((e) => console.log(e));
          });
        })
        .catch((e) => console.log(e));
    }
  };

  return (
    <>
      <Loader show={show} />
      <div>
        {auction_details.length > 0 ? (
          <>
            <center style={{ margin: "-15px 0 15px" }}>
              <Stepper
                steps={[
                  { title: "Auction Details" },
                  { title: "Select Transporters" },
                  { title: "Go to Auctions" },
                ]}
                activeStep={step}
                completeColor={"#54a63a"}
                completeTitleColor={"#54a63a"}
                activeColor={"#393186"}
                activeTitleColor={"#393186"}
                titleFontSize={14}
                size={28}
                circleFontSize={14}
              />
            </center>
            {step === 2 ? (
              <div style={{ textAlign: "center", color: "#393186" }}>
                <div>
                  <h3>Auction Created</h3>
                </div>
                <center>
                  <a
                    className="btn btn-sm btn-primary"
                    // target="_blank"
                    target="_self"
                    onClick={(e) => {
                      e.preventDefault();
                      Activity([
                        {
                          screen: "LoRRI Adhoc",
                          module: "Create Auction",
                          user_activity: "Go to Auction button Clicked",
                          timestamp: currentRequestTimeStamp(),
                          "userEmail": userDetails?.email, "userName": userDetails?.user_name, "companyname": userDetails.company_name
                            ? userDetails.company_name
                            : userDetails.email
                              ? userDetails.email.split("@")[1].split(".")[0]
                              : ""
                        },
                      ]);
                      mixpanel.track(
                        `User has clicked on create auction button`,
                        {
                          ApplicationName: `${Urls.mixpanelappname}`,
                          ScreenName: "LoRRI-Adhoc",
                          ModuleName: "my_enquiries",
                          ActivityLog: "userClickedGoToAuctionButton",
                          Data: `Go to Auction button clicked`,
                          Definition: `User has clicked on Go to Auction button`,
                          ActivityType: "event_view",
                          UserName: userDetails.user_name,
                          UserEmail: userDetails.email,
                          CompanyName: userDetails.company_name
                            ? userDetails.company_name
                            : userDetails.email
                              ? userDetails.email.split("@")[1].split(".")[0]
                              : "",
                        }
                      );
                      document.getElementById("close_contactus").click();
                      redirectToProcure("/auction");
                    }}
                    href={PROCURE_URLS.AUCTION}
                  >
                    Go to Auctions
                  </a>
                </center>
              </div>
            ) : (
              <>
                <div className={classes["procurement_name"]}>
                  <div style={{ padding: "1%" }}>
                    <b>Procurement Name: </b>
                  </div>
                  <div style={{ width: isMobile() ? "" : "35%" }}>
                    <input
                      type="text"
                      style={{ margin: "0" }}
                      value={procurementName}
                      onChange={(e) => setProcurementName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className={classes["extends"]}>
                      <div className={`${classes["label"]}`}>
                        <b>Extends when (minutes):</b>
                      </div>
                      <div className={`${classes["value"]}`}>
                        <input
                          type="number"
                          name="auto_extend_when"
                          value={extendswhen > 0 ? extendswhen : ""}
                          placeholder="0"
                          onChange={(e) =>
                            changeHandler(
                              e.target.name,
                              parseInt(e.target.value)
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className={classes["extends"]}>
                      <div className={`${classes["label"]}`}>
                        <b>Extends by (minutes):</b>
                      </div>
                      <div className={`${classes["value"]}`}>
                        <input
                          type="number"
                          name="auto_extend_by"
                          placeholder="0"
                          value={extendsby > 0 ? extendsby : ""}
                          onChange={(e) =>
                            changeHandler(
                              e.target.name,
                              parseInt(e.target.value)
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className={classes["extends"]}>
                      <div className={`${classes["label"]}`}>
                        <b>Cap Extends by limit:</b>
                      </div>
                      <div className={`${classes["value"]}`}>
                        <input
                          type="number"
                          name="number_of_extension"
                          placeholder="0"
                          value={capLimit > 0 ? capLimit : ""}
                          onChange={(e) =>
                            changeHandler(
                              e.target.name,
                              parseInt(e.target.value)
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  {/* </div>
                <div className={`row`}> */}
                  <div className="col-md-3">
                    <div className={classes["extends"]}>
                      <div className={`${classes["label"]}`}>
                        <b>Duration (minutes):</b>
                      </div>
                      <div className={`${classes["value"]}`}>
                        <input
                          type="number"
                          placeholder="0"
                          value={duration > 0 ? duration : ""}
                          name="auction_duration"
                          onChange={(e) =>
                            changeHandler(
                              e.target.name,
                              parseInt(e.target.value)
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-3">
                    <div className={classes["extends"]}>
                      <span className={`${classes["label"]}`}>
                        <b>Display By:</b>
                      </span>
                      <form
                        style={{ width: "100%", padding: "0.5% 0 1% 0%" }}
                        className="d-flex justify-content-around align-items-end"
                      >
                        <input
                          checked={displayTransporter === true}
                          onClick={(e) => transporterDisplaySelection(e)}
                          type="radio"
                          id="transporter_name"
                        />
                        <span style={{ fontSize: "11px", marginLeft: "2%" }}>
                          Transporter Name
                        </span>
                        <br />
                        <input
                          checked={displayTransporter === false}
                          onClick={(e) => transporterDisplaySelection(e)}
                          type="radio"
                          id="transporter_id"
                        />
                        <span style={{ fontSize: "11px", marginLeft: "2%" }}>
                          Transporter ID
                        </span>
                      </form>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className={classes["extends"]}>
                      <span className={`${classes["label"]}`}>
                        <b>Zone:</b>
                      </span>
                      <select
                        className={`form-control `}
                        name="volume_unit"
                        style={{
                          width: "85%",
                          paddingTop: "4%",
                          height: "30px",
                          fontSize: "14px",
                        }}
                        onChange={(e) => setzone(e.target.value)}
                      >
                        <option style={{ fontSize: "14px" }} disabled>
                          Select Zone
                        </option>
                        <option value="central">Central</option>
                        <option value="east">East</option>
                        <option value="west">West</option>
                        <option value="north">North</option>
                        <option value="south">South</option>
                        <option selected value="PAN India">
                          PAN India
                        </option>
                      </select>
                      <div></div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className={classes["extends"]}>
                      <div className={`${classes["label"]}`}>
                        <b>Date and Start Time:</b>
                      </div>
                      <div className={`${classes["value"]}`}>
                        <DateTimePicker
                          min={new Date(newStartdate1)}
                          value={new Date(startdate)}
                          step={30}
                          inputProps={{
                            component: (props) => <input {...props} readOnly />,
                          }}
                          onChangeRaw={(event) => setStartdate()}
                          onChange={(e) => {
                            if (e && e !== null) {
                              setStartdate(new Date(e));
                              var temp_list = auction_details.slice();
                              temp_list = temp_list.map((enquiry) => {
                                enquiry["start_timestamp"] = e;
                                return enquiry;
                              });
                              setAuction_details(temp_list);
                            } else {
                              setStartdate();
                            }
                            console.log(e);
                          }}
                          // min={new Date(mindate)}
                          // max={new Date(maxdate)}
                          className={classes["datetimepicker"]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ width: "100%" }}>
                  {step === 0 ? (
                    <AuctionDetails
                      auction_details={auction_details}
                      setauction_details={setAuction_details}
                      step={step}
                    />
                  ) : null}
                  {step === 1 ? (
                    <Transporter
                      auction_list={auction_details}
                      setauction_list={setAuction_details}
                      procurement_level_list={auction_transporter_list}
                      setprocurement_level_list={setAuction_transporter_list}
                    />
                  ) : null}
                </div>
                {/* <div> */}
                <center style={{ padding: "1%" }}>
                  {step === 1 ? (
                    <button
                      className={`btn btn-sm btn-primary`}
                      style={{ margin: "0 1%" }}
                      onClick={(e) => setStep(step - 1)}
                    >
                      Previous
                    </button>
                  ) : null}
                  {step === 0 ? (
                    <button
                      className={"btn btn-sm btn-primary"}
                      style={{ margin: "0 1%" }}
                      onClick={(e) => {
                        if (validatedetails()) {
                          setStep(step + 1);
                        }
                      }}
                    >
                      Next
                    </button>
                  ) : (
                    <button
                      className={`btn btn-sm btn-success`}
                      style={{ margin: "0 1%" }}
                      onClick={(e) => createAuction()}
                    >
                      Create Auctions
                    </button>
                  )}
                </center>
                {/* </div> */}
              </>
            )}
          </>
        ) : (
          <div>
            {auctionlist.length > 0 ? (
              <center>
                <h4>Auction is already created for this enquiry.</h4>
                <center>
                  <a
                    className="btn btn-sm btn-primary"
                    // target="_blank"
                    target="_self"
                    onClick={(e) => {
                      e.preventDefault();
                      Activity([
                        {
                          screen: "Truck Available",
                          module: "Create Auction",
                          user_activity: "Go to Auction button Clicked",
                          timestamp: currentRequestTimeStamp(),
                          "userEmail": userDetails?.email, "userName": userDetails?.user_name, "companyname": userDetails.company_name
                            ? userDetails.company_name
                            : userDetails.email
                              ? userDetails.email.split("@")[1].split(".")[0]
                              : ""
                        },
                      ]);
                      mixpanel.track(
                        `User has clicked on create auction button`,
                        {
                          ApplicationName: `${Urls.mixpanelappname}`,
                          ScreenName: "LoRRI-Trucksavailable",
                          ModuleName: "my_enquiries",
                          ActivityLog: "userClickedGoToAuctionButton",
                          Data: `Go to Auction button clicked`,
                          Definition: `User has clicked on Go to Auction button`,
                          ActivityType: "event_view",
                          UserName: userDetails.user_name,
                          UserEmail: userDetails.email,
                          CompanyName: userDetails.company_name
                            ? userDetails.company_name
                            : userDetails.email
                              ? userDetails.email.split("@")[1].split(".")[0]
                              : "",
                        }
                      );
                      document.getElementById("close_contactus").click();
                      redirectToProcure("/auction");
                    }}
                    href={PROCURE_URLS.AUCTION}
                  >
                    Go to Auctions
                  </a>
                </center>
              </center>
            ) : (
              "Please select the lanes for creating auctions"
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Auctions;
